<template>
  <div class="page-wrapper">
    <div class="login-card">
      <div class="login-header">
        <div class="logo">
          <img src="/src/static/logo.png" alt="Egem" class="logo-img">
        </div>
        <h1 class="login-title">Bayi Girişi</h1>
        <p class="login-subtitle">
          Hesabınıza giriş yapmak için kullanıcı adı ve şifrenizi girin.
        </p>
      </div>

      <form onsubmit="event.preventDefault()" class="login-form">
        <div class="form-group">
          <label for="username">Kullanıcı adı veya e-posta</label>
          <input type="text" id="username" v-model="username" autocomplete="username">
        </div>

        <div class="form-group">
          <label for="password">Şifre</label>
          <input type="password" id="password" v-model="password" autocomplete="current-password">
        </div>

        <div class="form-footer">
          <div class="remember">
            <input type="checkbox" id="remember" v-model="securityBrowser">
            <label for="remember">Güvenli Tarayıcı</label>
          </div>
          <a href="#" class="link-small">Şifremi unuttum</a>
        </div>

        <button @click="handleSubmit()" class="btn-primary">Giriş yap</button>
      </form>

      <div class="login-extra">
        <span>Hesabınız yok mu?</span>
        <a href="#" class="link-normal">Yeni hesap oluştur</a>
      </div>

      <div class="login-footer">
        <select class="lang-select">
          <option value="tr">Türkçe (tr)</option>
          <option value="en">English (en)</option>
        </select>
        <span class="copy">&copy; 2025 Pm B2B V3.03</span>
      </div>
    </div>
  </div>
</template>

<script>
import { router } from '@/router';
import syncService from "@/services/syncService";
import db from '@/db';

export default {
  data () {
    return {
      username: '',
      password: '',
      loading: false,
      error: '',
      returnUrl: '',
      securityBrowser : localStorage.getItem('securityBrowser')
    };
  },
  created () {
    this.$store.setLoading([false, 'Oturum Açılıyor']);
    sessionStorage.removeItem('sync_redirected');
    //sessionStorage.removeItem('securityBrowser');

    this.returnUrl = this.$route.query.returnUrl || '/';
  },
  methods: {
    async handleSubmit () {
      this.error = '';
      this.loading = true;
      this.$store.setLoading([true, 'Bekleyiniz']);

      try {
        // 1) Login
        await this.$helper.login(this.username, this.password,this.securityBrowser);

        // 2) DB dolu mu? (stocks veya caris boşsa: ilk kurulum)
        this.$store.setLoading([true, 'Veriler kontrol ediliyor']);

        this.$store.setLoading([false, '']);
        router.push(this.returnUrl);

      } catch (e) {
        this.$store.setLoading([false, '...']);

        var msg = (e && (e.msg || e.message)) ? (e.msg || e.message) : 'Giriş sırasında hata oluştu';
        this.$store.showNotify({ type: 'danger', text: msg, timeout: 3000 });
        this.error = msg;

      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
/* Sayfa ortalama */
.page-wrapper {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: #dcdcdc;
}

/* Kart */
.login-card {
  width: 100%;
  max-width: 420px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow:
    0 10px 25px rgba(15, 23, 42, 0.18),
    0 0 0 1px rgba(148, 163, 184, 0.35);
  padding: 28px 26px 22px;
}

/* Header */
.login-header {
  margin-bottom: 18px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e5e7eb;
  text-align: center;
}

.centered-logo {
  justify-content: center;
}

.logo {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}

.logo-mark {
  width: 32px;
  height: 32px;
  border-radius: 10px;
  background: linear-gradient(135deg, #4158d0, #c850c0);
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 18px;
}

.logo-text {
  font-weight: 600;
  font-size: 17px;
  letter-spacing: 0.03em;
  color: #111827;
}

.login-title {
  font-size: 22px;
  font-weight: 600;
  margin-bottom: 4px;
}

.login-subtitle {
  font-size: 14px;
  color: #6b7280;
}

/* Form */
.login-form {
  margin-top: 10px;
}

.form-group {
  margin-bottom: 14px;
}

.form-group label {
  display: block;
  font-size: 13px;
  font-weight: 500;
  color: #374151;
  margin-bottom: 4px;
}

.form-group input {
  width: 100%;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  padding: 9px 10px;
  font-size: 14px;
  outline: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.form-group input:focus {
  border-color: #6366f1;
  box-shadow: 0 0 0 1px rgba(99, 102, 241, 0.3);
}

/* Form footer (remember + forgot) */
.form-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 4px 0 12px;
  font-size: 13px;
}

.remember {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.remember input[type="checkbox"] {
  width: 14px;
  height: 14px;
}

/* Button */
.btn-primary {
  width: 100%;
  border: none;
  border-radius: 999px;
  padding: 9px 14px;
  background: linear-gradient(135deg, #4f46e5, #6366f1);
  color: #ffffff;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: filter 0.15s ease, transform 0.05s ease;
}

.btn-primary:hover {
  filter: brightness(1.03);
}

.btn-primary:active {
  transform: scale(0.98);
}

/* Extra */
.login-extra {
  margin: 14px 0 10px;
  display: flex;
  justify-content: center;
  gap: 6px;
  font-size: 13px;
  color: #6b7280;
}

/* Links */
.link-small,
.link-normal {
  color: #4f46e5;
  text-decoration: none;
}

.link-small:hover,
.link-normal:hover {
  text-decoration: underline;
}

/* Footer */
.login-footer {
  border-top: 1px solid #e5e7eb;
  margin-top: 10px;
  padding-top: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  font-size: 12px;
  color: #9ca3af;
}

.lang-select {
  border-radius: 999px;
  border: 1px solid #e5e7eb;
  padding: 4px 8px;
  font-size: 12px;
  background: #f9fafb;
}

/* Responsive küçük ekranlar */
@media (max-width: 480px) {
  .login-card {
    padding: 22px 16px 18px;
  }

  .login-title {
    font-size: 20px;
  }

  .login-subtitle {
    font-size: 13px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login.vue